export const validateZipCode = (zip) => {
  console.log('validateZipCode called', zip)

  if (typeof zip !== 'string') return false;

  const cleaned = zip.trim();
  const zipRegex = /^\d{5}$/;

  return zipRegex.test(cleaned);

};
